import { render, staticRenderFns } from "./ImgSelectItem.vue?vue&type=template&id=174e6e44&scoped=true"
import script from "./ImgSelectItem.vue?vue&type=script&lang=js"
export * from "./ImgSelectItem.vue?vue&type=script&lang=js"
import style0 from "./ImgSelectItem.vue?vue&type=style&index=0&id=174e6e44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e6e44",
  null
  
)

export default component.exports